import {Directive, ElementRef, HostListener, Input, OnDestroy, Renderer2} from '@angular/core';

@Directive({
  selector: '[appExgAdaptiveHeight]'
})
export class AppExgAdaptiveHeightDirective implements OnDestroy {
  private observer: MutationObserver;

  @Input() set adaptiveHeightActive(value: boolean) {
    this._adaptiveHeightActive = value;
  }
  get adaptiveHeightActive(): boolean {
    return this._adaptiveHeightActive;
  }
  @Input() set adaptiveHeightOffset(value: number) {
    this._adaptiveHeightOffset = value;
  }
  get adaptiveHeightOffset(): number {
    return this._adaptiveHeightOffset;
  }

  @Input() set hasOffsetTop(value: boolean) {
    this._hasOffsetTop = value;
  }
  get hasOffsetTop(): boolean {
    return this._hasOffsetTop;
  }

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.observer = new MutationObserver(() => this.setPopupHeight());
    this.observeElement();
  }

  _adaptiveHeightActive = false;
  _adaptiveHeightOffset = 12;
  _hasOffsetTop = true;

  private observeElement(): void {
    this.observer.observe(this.el.nativeElement, {childList: true, subtree: true });
    this.setPopupHeight();
  }

  private setPopupHeight(): void {
    if (this.adaptiveHeightActive) {
      const viewportHeight = window.innerHeight;
      let availableHeight = viewportHeight - this.adaptiveHeightOffset;

      if (this.hasOffsetTop) {
        const offsetTop = this.el.nativeElement.getBoundingClientRect().top;
        availableHeight = availableHeight - offsetTop;
      }

      this.renderer.setStyle(this.el.nativeElement, 'max-height', `${availableHeight}px`);
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.setPopupHeight();
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }
}
